var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "version-box", class: { "text-center": _vm.$wf.isSmDown } },
    [
      _c("div", { class: { "right-align": !_vm.$wf.isSmDown } }, [
        _c(
          "h1",
          [
            _vm._v(
              " Winfakt " +
                _vm._s(_vm.$ct("common.tiers." + _vm.wfCompany.Tier)) +
                " "
            ),
            _vm.wfCompany.Tier == -1
              ? _c(
                  "w-link",
                  {
                    staticClass: "upgrade-button mls",
                    attrs: { to: "/account/activate?tier=0" },
                  },
                  [_vm._v(_vm._s(_vm.$ct("common.upgrade-now")))]
                )
              : _vm._e(),
            _vm.wfCompany.IsDemo
              ? _c("span", { staticClass: "demo" }, [_vm._v("Demo")])
              : _vm._e(),
          ],
          1
        ),
        _vm.daysTillActivation > 0 && !_vm.wfCompany.IsDemo
          ? _c("p", [_vm._v(" " + _vm._s(_vm.dayBeforeMsg) + " ")])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }